import React from 'react';
import Navbar from '@/components/landing/Navbar';
import Hero from '@/components/landing/Hero';
import StatsBar from '@/components/landing/StatsBar';
import Features from '@/components/landing/Features';
import HowItWorks from '@/components/landing/HowItWorks';
import Testimonials from '@/components/landing/Testimonials';
import FinalCta from '@/components/landing/FinalCta';
import Footer from '@/components/landing/Footer';

export default function Landing() {
    return (
        <main className="bg-black text-white min-h-screen">
            <Navbar />
            <Hero />
            <StatsBar />
            <Features />
            <HowItWorks />
            <Testimonials />
            <FinalCta />
            <Footer />
        </main>
    );
}
